import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Type } from '@classes/category/category';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryListsService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getCategoryList(idStep: string): Observable<Type[]> {
    return this.http.get<Type[]>(`${environment.apiUrl}/category-lists?stepId=${idStep}`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

}
